import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import * as actions from '../store/options.actions'
import { getServiceIdSelector } from '../../user/selectors/getServiceId.selector'
import { OptionsService } from '../services/options.service'
import { IOptionsResponse } from '../../../common/common.types'

export function* setBodySurveyMentalExamOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getAssessmentMentalExamOptions])
    const { entity } = response
    yield put(actions.setBodySurveyMentalOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setBodySurveyMentalExamOptions() error: ${e}`))
  }
}
export function* setBodySurveyMentalExamOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setBodySurveyMentalExamOptions)
}
